import translated, {WithTranslation} from 'utils/translated/transalted';

export const translatedKeyLangs = <T, TranslationsKey extends string>(
  object: WithTranslation<T, `${TranslationsKey}_langs`>,
  key: TranslationsKey
): string => translated(object, `${key}_langs` as `${TranslationsKey}_langs`);
